// extracted by mini-css-extract-plugin
export default {"selector":"style_selector__2mik3","checkbox":"style_checkbox__4UK73","img":"style_img__kmh--","label":"style_label__hnaHB","list":"style_list__OCfUY"};